import React from 'react';
import BaseComponent from './BaseContainer';
import { Redirect } from 'react-router-dom';
import LoginLayout from '../layout/LoginLayout';
import { AUTH_TOKEN, ROLES, PERMISSIONS, USER } from '../constants';
import { graphql, compose } from 'react-apollo';
import login from '../apollo/graphql/user/login';

class LoginContainer extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      email: '',
      password: '',
      message: null,
    };
  }

  render() {
    if (localStorage.getItem(AUTH_TOKEN) !== null) {
      return <Redirect to="/home" />;
    }
    return (
      <LoginLayout
        onChange={this._change}
        onSubmit={this._confirm}
        message={this.state.message}
        loading={this.state.loading}
      />
    );
  }

  _change = (arg) => {
    if (arg.type === 'email') {
      this.setState({ email: arg.value });
    } else if (arg.type === 'password') {
      this.setState({ password: arg.value });
    }
  };

  _confirm = async () => {
    this.setState({ loading: true });
    try {
      const { email, password } = this.state;
      const result = await this.props.loginMutation({
        variables: {
          email,
          password,
        },
      });

      if (result.data.login) {
        this._saveUserData(result.data.login);
        this.props.history.push('home');
      }
    } catch (e) {
      this.setState({
        loading: false,
        message: {
          type: 'error',
          header: 'Erreur',
          content: `Erreur (${e.message})`,
        },
      });
    }
  };

  _saveUserData = (data) => {
    const { token, roles, permissions, user } = data;
    localStorage.setItem(AUTH_TOKEN, token);
    localStorage.setItem(ROLES, roles);
    localStorage.setItem(PERMISSIONS, permissions);
    localStorage.setItem(USER, user.email);
  };
}

export default compose(graphql(login, { name: 'loginMutation' }))(
  LoginContainer,
);



// WEBPACK FOOTER //
// ./src/containers/LoginContainer.js